import React, { useState } from "react";
import "./FeedbackModal.css";

interface FeedbackModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (rating: number, comment: string) => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ show, onClose, onSubmit }) => {
  const [rating, setRating] = useState<number>(5);
  const [comment, setComment] = useState("");

  if (!show) return null;

  const handleSubmit = () => {
    if (rating >= 1 && rating <= 5) {
      onSubmit(rating, comment);
      setRating(5);
      setComment("");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="feedback-modal">
        <h2>Feedback Form</h2>

        <label>Rate the user:</label>
        <select value={rating} onChange={(e) => setRating(parseInt(e.target.value))}>
          <option value={5}>★★★★★</option>
          <option value={4}>★★★★☆</option>
          <option value={3}>★★★☆☆</option>
          <option value={2}>★★☆☆☆</option>
          <option value={1}>★☆☆☆☆</option>
        </select>

        <label>Your Comment:</label>
        <textarea
          placeholder="Enter your feedback..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />

        <div className="feedback-buttons">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-submit" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
